import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const ContactFormComponent = () => {
  const history = useHistory();

  useEffect(() => {
    history.replace('/contacte/formulari-de-contacte');
  }, [history]);

  return null;
};

export default ContactFormComponent;